
import { CITY_ALIASES } from "@constants/cities";

export const normalizeCityName = (cityName: string): string => {
  if (!cityName) return '';

  let decodedName: string;
  try {
    decodedName = decodeURIComponent(cityName);
  } catch {
    decodedName = cityName;
  }

  const normalizedCityName = decodedName
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[()]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  return CITY_ALIASES[normalizedCityName] || normalizedCityName;
};
